export default __webpack_public_path__ + "static/media/Locomotive.256.79300fbf.png";